import { useState } from 'react';

interface Toast { msg: string; type: 'success' | 'error' }

const ProfileSection = () => {
  const [form, setForm] = useState({
    username: 'kullanici_42',
    displayName: 'Ahmet K.',
    bio: 'Yeni insanlarla tanışmayı ve farklı kültürleri keşfetmeyi seviyorum.',
    birthYear: '1998',
  });
  const [toast, setToast] = useState<Toast | null>(null);
  const [saving, setSaving] = useState(false);
  const [avatarHover, setAvatarHover] = useState(false);

  const showToast = (msg: string, type: Toast['type'] = 'success') => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.username.trim()) { showToast('Kullanıcı adı boş olamaz.', 'error'); return; }
    if (form.username.length < 3) { showToast('Kullanıcı adı en az 3 karakter olmalı.', 'error'); return; }
    setSaving(true);
    setTimeout(() => {
      setSaving(false);
      showToast('Profil başarıyla güncellendi.');
    }, 1000);
  };

  return (
    <div>
      {/* Toast */}
      {toast && (
        <div
          className={`fixed top-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-2xl border backdrop-blur-xl text-sm font-medium shadow-2xl transition-all ${
            toast.type === 'success'
              ? 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400'
              : 'bg-red-500/10 border-red-500/30 text-red-400'
          }`}
        >
          <i className={`${toast.type === 'success' ? 'ri-checkbox-circle-line' : 'ri-error-warning-line'}`} />
          {toast.msg}
        </div>
      )}

      <div className="mb-8">
        <h2 className="text-xl font-extrabold text-white mb-1">Profilim</h2>
        <p className="text-white/40 text-sm">Diğer kullanıcıların göreceği bilgilerini düzenle.</p>
      </div>

      {/* Avatar */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-8 p-6 rounded-2xl bg-white/3 border border-white/8">
        <div
          className="relative w-20 h-20 rounded-2xl overflow-hidden cursor-pointer flex-shrink-0"
          onMouseEnter={() => setAvatarHover(true)}
          onMouseLeave={() => setAvatarHover(false)}
        >
          <img
            src="https://readdy.ai/api/search-image?query=young%20person%20casual%20portrait%2C%20neutral%20expression%2C%20minimal%20background%2C%20avatar%20style%2C%20soft%20lighting%2C%20realistic%20photo&width=160&height=160&seq=profileavatar&orientation=squarish"
            alt="Avatar"
            className="w-full h-full object-cover object-top"
          />
          {avatarHover && (
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
              <i className="ri-camera-line text-white text-xl" />
            </div>
          )}
        </div>
        <div className="flex-1">
          <p className="text-white font-semibold text-sm mb-1">Profil Fotoğrafı</p>
          <p className="text-white/40 text-xs mb-3">JPG veya PNG, max 5MB. Yüzünü gösterme zorunlu değil.</p>
          <div className="flex flex-wrap gap-2">
            <button className="px-4 py-2 rounded-xl bg-cyan-500/15 border border-cyan-500/25 text-cyan-400 text-xs font-semibold hover:bg-cyan-500/25 transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-upload-line mr-1" /> Fotoğraf Yükle
            </button>
            <button className="px-4 py-2 rounded-xl bg-white/5 border border-white/10 text-white/40 text-xs font-semibold hover:bg-white/8 hover:text-white/60 transition-all cursor-pointer whitespace-nowrap">
              Kaldır
            </button>
          </div>
        </div>
      </div>

      {/* Form */}
      <form onSubmit={handleSave} className="flex flex-col gap-5">
        {/* Username */}
        <div>
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-2">
            Kullanıcı Adı <span className="text-red-400">*</span>
          </label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-white/25 text-sm font-mono">@</span>
            <input
              type="text"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value.replace(/\s/g, '_').toLowerCase() })}
              maxLength={24}
              className="w-full pl-8 pr-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-white/25 focus:outline-none focus:border-cyan-500/50 transition-colors"
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-white/20 text-xs">{form.username.length}/24</span>
          </div>
          <p className="text-white/25 text-xs mt-1.5">Sadece harf, rakam ve alt çizgi kullanılabilir.</p>
        </div>

        {/* Display name */}
        <div>
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-2">
            Görünen Ad
          </label>
          <input
            type="text"
            value={form.displayName}
            onChange={(e) => setForm({ ...form, displayName: e.target.value })}
            maxLength={32}
            placeholder="Adınız veya takma adınız"
            className="w-full px-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-white/25 focus:outline-none focus:border-cyan-500/50 transition-colors"
          />
        </div>

        {/* Bio */}
        <div>
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-2">
            Biyografi
          </label>
          <textarea
            value={form.bio}
            onChange={(e) => setForm({ ...form, bio: e.target.value })}
            maxLength={160}
            rows={3}
            placeholder="Kendinizi kısaca tanıtın..."
            className="w-full px-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm placeholder-white/25 focus:outline-none focus:border-cyan-500/50 transition-colors resize-none"
          />
          <p className="text-white/25 text-xs mt-1 text-right">{form.bio.length}/160</p>
        </div>

        {/* Birth year */}
        <div>
          <label className="block text-white/50 text-xs font-semibold uppercase tracking-widest mb-2">
            Doğum Yılı
          </label>
          <select
            value={form.birthYear}
            onChange={(e) => setForm({ ...form, birthYear: e.target.value })}
            className="w-full sm:w-48 px-4 py-3.5 rounded-xl bg-white/5 border border-white/10 text-white text-sm focus:outline-none focus:border-cyan-500/50 transition-colors cursor-pointer"
          >
            {Array.from({ length: 50 }, (_, i) => 2006 - i).map((yr) => (
              <option key={yr} value={String(yr)}>{yr}</option>
            ))}
          </select>
          <p className="text-white/25 text-xs mt-1.5">Yalnızca 18+ kullanıcılar platforma erişebilir.</p>
        </div>

        {/* Save */}
        <div className="pt-2 flex items-center gap-4">
          <button
            type="submit"
            disabled={saving}
            className="px-8 py-3.5 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-bold text-sm hover:from-cyan-400 hover:to-violet-500 transition-all cursor-pointer disabled:opacity-60 whitespace-nowrap shadow-lg shadow-cyan-500/20"
          >
            {saving ? (
              <span className="flex items-center gap-2">
                <i className="ri-loader-4-line animate-spin" /> Kaydediliyor...
              </span>
            ) : (
              <span className="flex items-center gap-2">
                <i className="ri-save-line" /> Değişiklikleri Kaydet
              </span>
            )}
          </button>
          <button
            type="button"
            className="text-white/35 text-sm hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap"
            onClick={() => setForm({ username: 'kullanici_42', displayName: 'Ahmet K.', bio: 'Yeni insanlarla tanışmayı ve farklı kültürleri keşfetmeyi seviyorum.', birthYear: '1998' })}
          >
            Sıfırla
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProfileSection;
